<template>
    <section>
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiTable }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Member Utilizations
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>
        <!-- MEMBER UTILIZATION -->
        <UtilTable :get-user-util="getUtil" />
    <!-- END MEMBER UTILIZATION -->
    </section>
</template>

<script>
import { mdiTable } from '@mdi/js'
import UtilTable from './MemberUtilComp/UtilTable.vue'

import { mapActions, mapGetters } from 'vuex'
export default {
    components: { UtilTable },
    data: () => ({
        mdiTable
    }),
    computed: {
        ...mapGetters(['getUtil'])
    },
    async mounted() {
        this.displayUtil({ MEMBN: this.$cookies.get('usermembn') })
    },
    methods: {
        ...mapActions(['displayUtil', 'getCsrfToken'])
    }
}
</script>

<style scoped>
section {
  background-image: url("../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}

@media (max-width: 390px) {
  .page-icon {
    display: none;
  }
}

@media (max-width: 599px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}
@media (min-width: 599px) and (max-width: 968px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}
@media (min-width: 968px) and (max-width: 1264px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}
</style>
